import { Space, Button } from 'antd';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type FinderVehicleSpecsFragment } from '../../../../api/fragments/FinderVehicleSpecs';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import AddLtaForm from './AddLtaForm';

type AddLtaDrawerProps = {
    onClose: (lta?: Partial<FinderVehicleSpecsFragment['lta']>) => void;
    visible: boolean;
};

const AddLtaDrawer = ({ onClose, visible }: AddLtaDrawerProps) => {
    const { t } = useTranslation(['finderVehicle']);

    const onButtonClose = useCallback(() => onClose(), [onClose]);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onButtonClose}>{t('finderVehicle:addLtaDrawer.cancelButton')}</Button>
                    <Button form="addLta" htmlType="submit" type="primary">
                        {t('finderVehicle:addLtaDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onButtonClose}
            title={t('finderVehicle:addLtaDrawer.title')}
            visible={visible}
            destroyOnClose
        >
            <AddLtaForm onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default AddLtaDrawer;

type SetLta = (lta: Partial<FinderVehicleSpecsFragment['lta']>) => void;

export const useAddLtaFormDrawer = (setLta: SetLta) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: (lta?: Partial<FinderVehicleSpecsFragment['lta']>) => {
                // fill data if there's any
                if (lta) {
                    setLta(lta);
                }

                setVisible(false);
            },
        }),
        [setVisible, setLta]
    );

    return {
        ...actions,
        render: () => <AddLtaDrawer onClose={actions.close} visible={visible} />,
    };
};
